import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const CMCHistory = () => {
     useEffect(() => {
        document.title = 'CMC History-  St Peters convent School Faridabad Haryana';  
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  About Us  </li> 
     <li>CMC History </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>CMC History  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
       <img src="https://webapi.entab.info/api/image/STPSFH/public/Images/comingsoon.jpg" className="img-fluid mx-auto d-block"/> 
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default CMCHistory
